// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useFormik } from 'formik';
import * as _ from 'lodash';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
// COMPONENTS
import { Modal, Spinner, Form, Container, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
// CUSTOM COMPONENTS
import ModalBlock from '../../../../components/ModalBlock';
import CustomBlock from '../../../../components/CustomBlock';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import Button from '../../../../components/Button';
// SERVICES AND HELPERS
import * as jobService from '../../../../../services/service/jobService';
import * as jobTeamMemberService from '../../../../../services/service/jobTeamMemberService';
import * as helper from '../../../../../helpers/helper';
import * as jobScheduleService from '../../../../../services/service/jobScheduleService';
import constants from '../../../../../constants/constants';

const JobScheduleInfoBlock = (props) => {
    const { showAlert, scheduleInfo, setScheduleInfo, showConfirmModal, hideConfirmModal, fetchJobSchedules, setProcessing, fromDashboard } = props;
    const [tempScheduleInfo, setTempScheduleInfo] = useState(null);

    useEffect(() => {
        if (scheduleInfo !== null) {
            setTempScheduleInfo(scheduleInfo);
        }
    }, [scheduleInfo])

    const handleModalClose = () => {
        setScheduleInfo(null);
    }

    const handleRemoveSchedule = () => {
        jobScheduleService.deleteJobSchedule(tempScheduleInfo.id).then(res => {
            fetchJobSchedules();
            showAlert({ message: res.message, variant: 'success' });
            handleModalClose();
            hideConfirmModal();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => hideConfirmModal());
    }

    return (
        <>
            <ModalBlock
                centered
                size="md"
                show={scheduleInfo !== null}
                onHide={handleModalClose}
                closeAction
                closeActionOnClick={handleModalClose}
            >
                {
                    scheduleInfo !== null &&
                    <CustomBlock className="job-info-block">
                        <CustomBlock className="header-block">
                            <CustomBlock className="image-block">
                                <CustomBlock
                                    className="image"
                                    style={{ backgroundImage: `url(${scheduleInfo.imageUrl ? (constants.API_URL + scheduleInfo.imageUrl) : ("/media/users/default.jpg")})` }}
                                />
                            </CustomBlock>

                            <CustomBlock className="text-block">
                                <h3 className="text">
                                    {scheduleInfo.name}
                                </h3>
                                <h4 className="subtitle">{scheduleInfo.jobRole}</h4>
                            </CustomBlock>
                        </CustomBlock>
                        <NavLink className="btn btn-primary" to={"/services/manage-job/schedule/" + scheduleInfo.jobId}>
                            Go to Job
                        </NavLink>
                        <CustomBlock className="info-block">
                            <CustomBlock className="info">
                                <h3 className="title">Job Location</h3>
                                <p className="description">
                                    {scheduleInfo.location}
                                </p>
                            </CustomBlock>

                            <CustomBlock className="info">
                                <h3 className="title">Job Schedule</h3>
                                <p className="description"><span>Start Time: </span>{moment(scheduleInfo.start).format("MM/DD/YYYY - HH:mm")}</p>
                                <p className="description"><span>End Time: </span>{moment(scheduleInfo.end).format("MM/DD/YYYY - HH:mm")}</p>
                            </CustomBlock>

                            <CustomBlock className="info">
                                <h3 className="title">Additional Notes</h3>
                                <p className="description">{scheduleInfo.additionalNotes ? scheduleInfo.additionalNotes : "No notes available"}</p>
                            </CustomBlock>

                            {
                                !fromDashboard && <CustomBlock className="content-container mt-5">
                                    <Button
                                        text="Remove From Schedule"
                                        className="danger--bg ml-0 mr-0"
                                        onClick={() => {
                                            handleModalClose();
                                            showConfirmModal({
                                                title: "Remove From Schedule",
                                                text: `
                                                <p class="mb-3">
                                                Are you sure you want to remove this user from the schedule?
                                                </p>
                                            `,
                                                rightBtnText: "Confirm",
                                                btnAction: () => handleRemoveSchedule()
                                            })
                                        }}
                                    />
                                </CustomBlock>
                            }
                        </CustomBlock>
                    </CustomBlock>
                }
            </ModalBlock>
        </>
    )
}

export default JobScheduleInfoBlock;